import React, { useContext, useState, useEffect, useRef, useCallback } from 'react';
import { getBranchDropdownListData, getBranchListApi, getConsignorDropdownListData, getConsignorLocationDropdownListData } from '_services/dropdownServices/dropdownService';
import { ButtonHeading, CityDropdownForTrip, CommonInput, CustomSelect } from 'components';
import { constant } from 'constants/constant';
import { UserContext } from 'context';
import { errorSchema, utils } from 'helper';
import { AddMasterLocationModal, BranchSeriesInvoiceModal, ConfirmModalFor } from 'modals';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import StorageService from 'utils/StorageServices/StorageServices';
import { getBillRaiseNumber } from '_services/invoiceBillRaiseServices';
import AddNewSeriesInvoiceModal from 'modals/AddNewSeriesInvoiceModal/AddNewSeriesInvoiceModal';
import { fetchInvoiceNumberData } from '_services/accountsServices/lrServices';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import { fetchConsignorDetailsData } from '_services/accountsServices/consignorServices';
import FirmImg from '../../assets/img/firm.png'
import toast from 'react-hot-toast';

const formObj = {
    company_id: '',
    consignor_id: {},
    action_type: 2,
    billraise_type: { label: "Freight + Claims", value: 1 },
    invoice_number: '',
    invoice_date: '',
    due_date: '',
    branch_id: {},
    charge_gst: 0,
    gst_percentage: {},
    // tds: {},
    receiving_state: {},
    select_lr_ids: [],
    select_claim_ids: [],
    charge_gst_button: false,
    consignor_location: {},
    due_days: { label: "15 Days", value: 15 }

    // invoice_summary: {
    //     total_freight: '',
    //     claim_receivable: '',
    //     gst_amount: '',
    //     invoice_amount: '',
    //     freight_received: '',
    //     claim_payable: '',
    //     balance: '',
    // }
}

const BillRaise = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { masterData, states, invoiceBillRaiseData, setInvoiceBillRaiseData, setInvoiceTableToggle } = useContext(UserContext)
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);
    const [dropdownConsignorList, setDropdownConsignorList] = useState([]);
    const [consignorLocationList, setConsignorLocationList] = useState([]);
    const [dropdownBranchList, setDropdownBranchList] = useState([]);
    const [leaveShowConfirm, setLeaveShowConfirm] = useState(false);
    const [locationLoading, setLocationLoading] = useState(false);

    const hiddenInputRef = useRef(null);
    const [showBackModal, setShowBackModal] = useState(false);

    const [isOpenInvoiceSeries, setIsOpenInvoiceSeries] = useState(false);
    const [showAddNewInvoiceSeries, setShowAddNewInvoiceSeries] = useState(false);
    const [isSetInvoiceSeries, setIsSetInvoiceSeries] = useState("");
    const [isEditInvoice, setIsEditInvoice] = useState(false);
    const [isInvoiceNumber, setIsInvoiceNumber] = useState("");

    const shouldReloadRef = useRef(false);

    const [detailsData, setDetailsData] = useState({});
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [addressId, setAddressId] = useState({
        id: "",
        title: "location",
        view: false,
    });

    const getDropdownLocationDataList = async (value) => {
        setLocationLoading(true)
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                consignor_id: value,
            }
            const res = await getConsignorLocationDropdownListData(object);
            if (res?.responseCode == 200) {
                let data = res?.data?.locations?.map((el) => {
                    let val = el?.gst_no ? `(${el?.gst_no})` : `(No Gst)`
                    return {
                        ...el,
                        label: `${el?.attention} ${val}`,
                        value: el?._id,
                    }
                })
                setConsignorLocationList(data);
                setLocationLoading(false);
            }
        } catch (error) {
            setLocationLoading(false);
            throw error;
        }
    }

    const getDataConsignorDetails = async (id_1, id_2, eventData) => {
        try {
            // if (loadingBarRef.current) {
            //     loadingBarRef.current.continuousStart(); // Start the loading bar
            // }
            let object = {
                consignor_id: id_1,
                company_id: id_2,
            };
            const res = await fetchConsignorDetailsData(object);
            if (res?.responseCode == 200) {
                setDetailsData(res?.data?.consignor);
                if (eventData?._id) {
                    setAddressId((s) => ({
                        ...s,
                        id: eventData?._id,
                        title: "loaction",
                        view: false,
                    }));
                    setShowOffcanvas(true);
                }
                if (eventData?.stateUpdate && !eventData?.action) {
                    getDropdownLocationDataList(formValue?.consignor_id?.value);
                }
            }
        } catch (error) {
            console.error(error);
        }
        //  finally {
        //     if (loadingBarRef.current) {
        //         loadingBarRef.current.complete(); // Complete the loading bar
        //     }
        // }
    };

    const getDropdownDataConsignorList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
            }
            const res = await getConsignorDropdownListData(object);
            if (res?.responseCode == 200) {
                let responseData = res?.data?.consignor_list?.map((el) => {
                    return {
                        ...el,
                        label: el?.name,
                        value: el?._id,
                    }
                })
                setDropdownConsignorList(responseData)
            }
        } catch (error) {
            throw error;
        }
    }

    const getSeriesBillRaise = async (branchId) => {
        try {
            let object = {
                branch_id: branchId?._id,
            }
            const res = await getBillRaiseNumber(object);
            if (res?.responseCode == 200) {
                return res?.data?.billraise_number;
                // handleOnChange('invoice_number', )
                // setFormValue((s) => ({
                //     ...s,
                //     invoice_number: res?.data?.billraise_number,
                // }))
            }
        } catch (error) {
            throw error;
        }
    }

    const getDropdownDataBranchList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                limit: 100,
                offset: 1,
                search: "",
            };
            const res = await getBranchDropdownListData(object);
            if (res?.responseCode == 200) {

                let arrayData = res?.data?.branch_list?.map((el) => {
                    return {
                        ...el,
                        label: el?.branch,
                        value: el?._id,
                    }
                })?.reverse();
                setDropdownBranchList(arrayData);

                if (arrayData?.length > 0 && arrayData?.length === 1) {
                    let value = await getSeriesBillRaise(arrayData[0]);
                    setFormValue((s) => ({
                        ...s,
                        branch_id: arrayData[0],
                        invoice_number: value,
                    }))
                }
            }
        } catch (error) {
            // throw error;
        }
    };

    useEffect(() => {
        getDropdownDataConsignorList();
        getDropdownDataBranchList();
    }, [masterData, StorageService.getCompanyId()])

    useEffect(() => {
        if (StorageService.getCompanyId() && formValue?.consignor_id?.value) {
            getDropdownLocationDataList(formValue?.consignor_id?.value);
            // setInvoiceBillRaiseData({ ...formValue, consignor_location: {}, select_lr_ids: [] })
        }
    }, [StorageService.getCompanyId(), formValue?.consignor_id])

    // const getSeriesBillRaise = async (branchId) => {
    //     try {
    //         let object = {
    //             branch_id: branchId?._id,
    //         }
    //         const res = await getBillRaiseNumber(object);
    //         if (res?.responseCode == 200) {
    //             return res?.data?.billraise_number;
    //             // handleOnChange('invoice_number', )
    //             // setFormValue((s) => ({
    //             //     ...s,
    //             //     invoice_number: res?.data?.billraise_number,
    //             // }))
    //         }
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    const getDataInvoiceNumber = async (id) => {
        try {
            let object = {
                branch_id: id,
            };
            const res = await fetchInvoiceNumberData(object);
            if (res?.responseCode == 200) {
                return res?.data?.trip_number;
                // setFormValue((s) => ({ ...s, invoice_number: res?.data?.trip_number }));
                // setInvoiceSeries(res?.data?.billraise_number);
            }
        } catch (error) {
            // throw error;
        }
    };

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        if (name === 'charge_gst_button' && value === false) {
            stateObj['charge_gst'] = 0;
            stateObj['gst_percentage'] = {};
            stateObj['receiving_state'] = {};
        }
        if (name === 'charge_gst' && value === 1) {
            stateObj['receiving_state'] = {};
        }
        if (name === 'action_type') {
            stateObj['billraise_type'] = { label: "Freight + Claims", value: 1 }
        }
        if (name === 'due_date') {
            stateObj['due_days'] = { label: "Custom", value: '' }
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createBillRaiseSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        if (name === 'consignor_id') {
            stateObj['consignor_location'] = {}
            if (item?.gst_charges > 0) {
                stateObj['charge_gst_button'] = true;
                stateObj['charge_gst'] = item?.gst_charges;
            } else {
                stateObj['charge_gst_button'] = false;
                stateObj['charge_gst'] = item?.gst_charges;
                stateObj['gst_percentage'] = {};
                stateObj['receiving_state'] = {};
            }
        }
        if (name === 'branch_id') {
            // let number = await getDataInvoiceNumber(item);
            let value = await getSeriesBillRaise(item);
            stateObj['invoice_number'] = value; // number ? number : value;
        }
        // if (name === 'consignor_location') {
        //     // setInvoiceBillRaiseData({ ...formValue, consignor_location: item }); // select_lr_ids: [] 
        // }

        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createBillRaiseSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.createBillRaiseSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            if (formValue?.charge_gst_button && formValue?.consignor_location?.value && !formValue?.consignor_location?.gst_state?.value) return;
            if (formValue?.charge_gst_button && formValue?.branch_id?.value && !formValue?.branch_id?.gst_state?.value) return;
            if (formValue?.billraise_type?.value === 3) {
                let object = { ...formValue }
                // delete object.charge_gst_button;
                setInvoiceBillRaiseData({ ...object, select_lr_ids: [] });
                navigate('/invoicing/select_claims')
            } else {
                let object = { ...formValue }
                // delete object.charge_gst_button;
                setInvoiceBillRaiseData({ ...object, select_claim_ids: [] });
                navigate('/invoicing/selectlr')
            }
            setFormError("");
        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            invoice_date: utils.getTodayDate(),
            company_id: StorageService.getCompanyId(),
        }));
    }, [dropdownConsignorList, masterData, StorageService.getCompanyId()]);

    useEffect(() => {
        if (location?.state?.branch?._id && location?.state?.consignor?._id) {
            let filterBranch = dropdownBranchList?.find((el) => el?._id === location?.state?.branch?._id);
            let filterConsignor = dropdownConsignorList?.find((el) => el?._id === location?.state?.consignor?._id);
            let result = filterConsignor?.value ? filterConsignor : {label: location?.state?.consignor?.name, value: location?.state?.consignor?._id};

            const stateObj = {
                ...formValue,
                invoice_date: utils.getTodayDate(),
                company_id: StorageService.getCompanyId(),
                branch_id: filterBranch,
                consignor_id: result,
            };
            // stateObj['consignor_location'] = {}
            if (filterConsignor?.gst_charges > 0) {
                stateObj['charge_gst_button'] = true;
                stateObj['charge_gst'] = filterConsignor?.gst_charges;
            } else {
                stateObj['charge_gst_button'] = false;
                stateObj['charge_gst'] = filterConsignor?.gst_charges;
                stateObj['gst_percentage'] = {};
                stateObj['receiving_state'] = {};
            }
            setFormValue(stateObj);
            setInvoiceBillRaiseData(stateObj);
        }
    }, [dropdownConsignorList, dropdownConsignorList, StorageService.getCompanyId(), location?.state]);

    useEffect(() => {
        if (location?.state?.branch?._id) {
            let filterBranch = dropdownBranchList?.find((el) => el?._id === location?.state?.branch?._id);
            if (filterBranch?._id && filterBranch?.value) {
                onhandleSelect(filterBranch, 'branch_id');
            }
        }
    }, [location?.state?.branch?._id, dropdownBranchList])

    useEffect(() => {
        if (formValue?.invoice_date) {
            setFormValue((s) => ({
                ...s,
                due_date: utils.getDateFifteenDaysAfterDate(formValue?.invoice_date),
                due_days: { label: "15 Days", value: 15 }
            }))
        }

    }, [formValue?.invoice_date])

    useEffect(() => {
        if (invoiceBillRaiseData?.consignor_id?.value) {
            // setFormValue((s) => ({ ...s, charge_gst_button: true }))
            // setFormValue(invoiceBillRaiseData);
            setFormValue((s) => ({
                ...s,
                company_id: StorageService.getCompanyId(),
                consignor_id: invoiceBillRaiseData?.consignor_id,
                consignor_location: invoiceBillRaiseData?.consignor_location,
                action_type: invoiceBillRaiseData?.action_type,
                billraise_type: invoiceBillRaiseData?.billraise_type,
                invoice_number: invoiceBillRaiseData?.invoice_number,
                invoice_date: utils.getTodayDate(invoiceBillRaiseData?.invoice_date), // invoiceBillRaiseData?.invoice_date
                due_date: utils.getTodayDate(invoiceBillRaiseData?.due_date), // invoiceBillRaiseData?.due_date
                due_days: invoiceBillRaiseData?.due_days,
                branch_id: invoiceBillRaiseData?.branch_id,
                charge_gst: invoiceBillRaiseData?.charge_gst,
                gst_percentage: invoiceBillRaiseData?.gst_percentage,
                receiving_state: invoiceBillRaiseData?.receiving_state,
                select_lr_ids: [],
                select_claim_ids: [],
                charge_gst_button: invoiceBillRaiseData?.charge_gst_button,
                // charge_gst_button: invoiceBillRaiseData?.gst_percentage?.value > 0 ? true : false,
            }))
        }
    }, [invoiceBillRaiseData])

    const submitLeaveModalProps = () => {
        navigate('/invoicing')
    }

    const discardHandlerFunction = (e) => {
        e.preventDefault();
        if (formValue?.consignor_id?.label || formValue?.invoice_number || formValue?.branch_id?.label || formValue?.charge_gst || formValue?.gst_percentage?.label || formValue?.receiving_state?.label) {
            setLeaveShowConfirm(true);
        } else {
            submitLeaveModalProps();
        }
        // setInvoiceTableToggle(false);
    }

    let leaveModalProps = {
        show: leaveShowConfirm,
        closeModal: (e) => setLeaveShowConfirm(!leaveShowConfirm),
        title: "Leave This Page",
        submitTitle: "Confirm",
        onSubmit: submitLeaveModalProps,
        confirmModal: "confirmModal",
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (!shouldReloadRef.current) {
                event.preventDefault();
                event.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    // browser back button functionality

    const backModalProps = {
        show: showBackModal,
        closeModal: (e) => setShowBackModal(false),
        title: "Leave This Page",
        submitTitle: "Confirm",
        onSubmit: submitLeaveModalProps,
        confirmModal: "confirmModal",
    };

    useEffect(() => {
        const handlePopState = (event) => {
            event.preventDefault();
            setShowBackModal(true);
            window.history.pushState({ modalOpened: false }, "");
        };

        window.addEventListener("popstate", handlePopState);
        window.history.pushState({ modalOpened: false }, "");

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);

    useEffect(() => {
        if (consignorLocationList?.length > 0 && consignorLocationList?.length === 1) {
            setFormValue((s) => ({
                ...s,
                consignor_location: consignorLocationList[0],
            }))
        }
    }, [consignorLocationList])

    let isInvoiceSeriesModalProps = {
        isOpen: isOpenInvoiceSeries,
        closeModal: () => setIsOpenInvoiceSeries(!isOpenInvoiceSeries),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Select Invoice Series",
        formData: formValue,
        submitTitle: "Save",
        nextModal: (e) => setShowAddNewInvoiceSeries(true),
        setIsEditLR: (e) => setIsEditInvoice(e),
        setLrSeries: (e) => setIsSetInvoiceSeries(e),
        setIsLrNumber: (value) => handleOnChange('invoice_number', value),
        // setIsLrNumber: (value) => setFormValue((s) => ({ ...s, invoice_number: value })),
    };

    let addNewSeriesInvoiceModalProps = {
        isOpen: showAddNewInvoiceSeries,
        closeModal: () => setShowAddNewInvoiceSeries(!showAddNewInvoiceSeries),
        headerPart: false,
        footerPart: false,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: isEditInvoice?._id ? "Edit New Series" : "Add New Series",
        submitTitle: isEditInvoice?._id ? "Update" : "Save",
        formData: formValue,
        isEditLR: isEditInvoice,
        onSubmit: (e) => setShowAddNewInvoiceSeries(false),
        previosModal: () => setIsOpenInvoiceSeries(!isOpenInvoiceSeries),
    };

    const handleInvoiceFunctionality = () => {
        if (formValue?.branch_id?.value) {
            setIsOpenInvoiceSeries(true);
        }
    };

    const handleEditAddress = (data, consignor_id) => {
        getDataConsignorDetails(consignor_id, StorageService.getCompanyId(), data);
    };

    const callSelectDateWiseFunction = (date, data) => {
        let finalDate = utils.getDateAfterDays(date, data?.value)
        setFormValue((s) => ({
            ...s,
            due_date: finalDate
        }))
    }

    const fetchBranch = useCallback(async (search, page, limit) => {
        try {
            const response = await getBranchListApi({
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                offset: page,
                limit,
                search,
            });

            if (response?.responseCode === 200) {
                const list = await response?.data?.branch_list?.map((i) => ({
                    ...i,
                    label: i?.branch,
                    value: i?._id
                }));

                return {
                    items: list,
                    total: response?.data?.total_record,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, []);

    return (
        <>
            <div>
                <div className='contentHead_new'>
                    <h4>Create Bill Raise</h4>

                    <div className='_stepedBxs'>
                        <div className='_seperateCheckes activated'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                <circle cx="10.4999" cy="10.5" r="10.5" fill="#20A154" />
                                <path d="M5.99988 10.1672L9.16704 13.3343L15.4999 7" stroke="white" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>

                            <span>Bill Details</span>
                        </div>

                        <div className='_seperateCheckes '>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                <circle cx="10.5" cy="10.5" r="10.5" fill="#D9D9D9" />
                                <path d="M6 10.1672L9.16716 13.3343L15.5 7" stroke="#828282" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>

                            <span>Select LR</span>
                        </div>

                        <div className='_seperateCheckes'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                <circle cx="10.5" cy="10.5" r="10.5" fill="#D9D9D9" />
                                <path d="M6 10.1672L9.16716 13.3343L15.5 7" stroke="#828282" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>

                            <span>Selected LR</span>
                        </div>

                        <div className='_seperateCheckes'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                <circle cx="10.5" cy="10.5" r="10.5" fill="#D9D9D9" />
                                <path d="M6 10.1672L9.16716 13.3343L15.5 7" stroke="#828282" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>

                            <span>Summary</span>
                        </div>
                    </div>
                </div>

                <div className='_billRaiseBody'>
                    <div className='billDetial_modBxs'>
                        <div className='billDetail_mdModal'>
                            <div className='pr_procssBx'>
                                <div className='pr_procssBx_grid'>

                                    <div className='singleDiv'>
                                        <CustomSelect
                                            options={dropdownConsignorList}
                                            name="consignor_id"
                                            label="Select Party"
                                            placeholder="Select Party"
                                            value={formValue?.consignor_id?.value ? formValue?.consignor_id : {}}
                                            error={formError["consignor_id.label"]}
                                            onSelect={(data) => onhandleSelect(data, 'consignor_id')}
                                        />
                                    </div>

                                    <div className='singleDiv'>
                                        <CustomSelect
                                            options={consignorLocationList}
                                            name="consignor_location"
                                            label="Location"
                                            placeholder={locationLoading ? "Loading..." : "Location"}
                                            value={formValue?.consignor_location?.value ? formValue?.consignor_location : {}}
                                            error={formError["consignor_location.label"]}
                                            onSelect={(data) => onhandleSelect(data, 'consignor_location')}
                                            onEdit={(data) => handleEditAddress(data, formValue?.consignor_id?.value)}
                                        />
                                        {(formValue?.charge_gst_button && formValue?.consignor_location?.value && !formValue?.consignor_location?.gst_state?.value) ? (
                                            <span className="input_drop_error">
                                                This Consignor location has no gst state.
                                            </span>
                                        ) : <></>}
                                    </div>

                                    <div className='singleDiv'>
                                        <div className='checkBx_lv rm_rf_pds'>
                                            {
                                                constant.ActionTypeArray?.map((el, ind) => {
                                                    return (
                                                        <React.Fragment key={ind}>
                                                            <div className='_dualCheckr_bx'>
                                                                <input
                                                                    className="form-check-input"
                                                                    id={+ind + "action_type" + el?.value}
                                                                    type="radio"
                                                                    name="action_type"
                                                                    checked={Number(formValue?.action_type) === Number(el?.value)}
                                                                    value={formValue?.action_type ? formValue?.action_type : ""}
                                                                    onChange={({ target: { name, value } }) =>
                                                                        handleOnChange(name, el?.value)
                                                                    }
                                                                />
                                                                <label htmlFor={+ind + "action_type" + el.value} className="form-check-label" >
                                                                    {el.label}
                                                                </label>
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>

                                    {/* <div className='singleDiv'>
                                        <CustomSelect
                                            options={constant.ActionTypeArray?.map((el) => {
                                                return {
                                                    label: el?.name,
                                                    value: el?.id,
                                                }
                                            })}
                                            name="action_type"
                                            label="Payment Receiving Mode"
                                            placeholder="Payment Receiving Mode"
                                            value={formValue?.action_type?.value ? formValue?.action_type : {}}
                                            error={formError["action_type.label"]}
                                            onSelect={(data) => onhandleSelect(data, 'action_type')}
                                        />
                                    </div> */}

                                    <div className='singleDiv'>
                                        <CustomSelect
                                            options={
                                                formValue?.action_type === 1 ? constant.typeArray1?.map((el) => {
                                                    return {
                                                        label: el?.name,
                                                        value: el?.id,
                                                    }
                                                }) : constant.typeArray2?.map((el) => {
                                                    return {
                                                        label: el?.name,
                                                        value: el?.id,
                                                    }
                                                })
                                            }
                                            name="billraise_type"
                                            label="Select type"
                                            placeholder="Select type"
                                            value={formValue?.billraise_type?.value ? formValue?.billraise_type : {}}
                                            error={formError["billraise_type.label"]}
                                            onSelect={(data) => onhandleSelect(data, 'billraise_type')}
                                        />
                                    </div>

                                    <div className='singleDiv'>
                                        <CityDropdownForTrip
                                            label={"Select Branch for Billing"}
                                            placeholder="Select Branch for Billing"
                                            fetchData={fetchBranch}
                                            pageSize={20}
                                            onChange={(data) => onhandleSelect(data, 'branch_id')}
                                            selectedItem={formValue?.branch_id?.value ? formValue?.branch_id : {}}
                                            error={formError["branch_id.label"]}
                                            errorMessage={formError["branch_id.label"]}
                                        />
                                        {formValue?.branch_id?.firm_id?.firm && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565" }}>
                                            <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                                            {formValue?.branch_id?.firm_id?.firm && formValue?.branch_id?.firm_id?.firm}
                                        </p>}
                                        {/* <CustomSelect
                                            options={dropdownBranchList}
                                            name="branch_id"
                                            label="Select Branch for Billing"
                                            placeholder="Select Branch for Billing"
                                            value={formValue?.branch_id?.value ? formValue?.branch_id : {}}
                                            error={formError["branch_id.label"]}
                                            onSelect={(data) => onhandleSelect(data, 'branch_id')}
                                        />
                                        {formValue?.branch_id?.firm_id?.firm && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565" }}>
                                            <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                                            {formValue?.branch_id?.firm_id?.firm && formValue?.branch_id?.firm_id?.firm}
                                        </p>} */}
                                        {(formValue?.charge_gst_button && formValue?.branch_id?.value && !formValue?.branch_id?.gst_state?.value) ? (
                                            <span className="input_drop_error">
                                                This Branch has no gst state.
                                            </span>
                                        ) : <></>}
                                    </div>

                                    <div className='halfDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="Invoice Number * "
                                            label="Invoice Number * "
                                            name='invoice_number'
                                            maxLength="10"
                                            disabled={!formValue?.branch_id?.value ? true : false}
                                            onInput={maxLengthCheck}
                                            value={formValue.invoice_number ? formValue.invoice_number : ''}
                                            onClick={handleInvoiceFunctionality}
                                            focus={!!(typeof formError === "object" && formError?.invoice_number)}
                                            error={!!(typeof formError === "object") ? formError?.invoice_number : ""}
                                            settingIcon={true}
                                            isSettingHnadle={handleInvoiceFunctionality}
                                        />
                                    </div>

                                    <div className='halfDiv'>
                                        {/* <CommonInput
                                            type="date"
                                            placeholder="As of Date"
                                            label="As of Date *"
                                            name='invoice_date'
                                            onKeyDown={(e) => e.preventDefault()}
                                            value={formValue.invoice_date}
                                            focus={!!(typeof formError === "object" && formError?.invoice_date)}
                                            error={!!(typeof formError === "object") ? formError?.invoice_date : ""}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        /> */}
                                        <DatePickerComponent
                                            label="As of Date"
                                            name='invoice_date'
                                            showTimeSelect={false}
                                            defaultTimeFix={false}
                                            startDate={formValue.invoice_date}
                                            onChange={(data) => handleOnChange('invoice_date', data)}
                                            error={!!(typeof formError === "object") ? formError?.invoice_date : ""}
                                        />
                                    </div>

                                    {/* <div className='singleDiv'>
                                        <DatePickerComponent
                                            label="Due Date * "
                                            name='due_date'
                                            showTimeSelect={false}
                                            defaultTimeFix={false}
                                            startDate={formValue.due_date}
                                            onChange={(data) => handleOnChange('due_date', data)}
                                            error={!!(typeof formError === "object") ? formError?.due_date : ""}
                                        />
                                    </div> */}

                                    <div className='singleDiv' style={{ position: 'relative' }}>
                                        <DatePickerComponent
                                            label="Due Date * "
                                            name='due_date'
                                            showTimeSelect={false}
                                            defaultTimeFix={false}
                                            startDate={formValue.due_date}
                                            onChange={(data) => handleOnChange('due_date', data)}
                                            error={!!(typeof formError === "object") ? formError?.due_date : ""}
                                        />
                                        <div className='__inrDropdown_bx'>
                                            <CustomSelect
                                                options={constant.invoiceDueDateArray}
                                                name="due_days"
                                                disabled={(!formValue?.due_date ? true : false)}
                                                placeholder="Custom"
                                                value={formValue?.due_days?.value ? formValue?.due_days : {}}
                                                onSelect={(data) => {
                                                    onhandleSelect(data, 'due_days');
                                                    callSelectDateWiseFunction(formValue.invoice_date, data);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className='singleDiv _gstChr_div'>
                                        <div className="_anvSwitcherNew form-check form-switch">
                                            <label className="form-check-label" htmlFor="charge_gst">Charge GST</label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='charge_gst'
                                                id="charge_gst"
                                                checked={formValue?.charge_gst_button === true}
                                                onChange={(e) => handleOnChange('charge_gst_button', e.target.checked)}
                                            />
                                        </div>

                                        {
                                            formValue?.charge_gst_button && (
                                                <div className='singleDiv _gstChr_div'>
                                                    <div className='_gstChr_dualChecker'>
                                                        <div className="_dualCheckr_bx" >
                                                            <input
                                                                className="form-check-input"
                                                                id="forward_charge_mechanism"
                                                                type="radio"
                                                                name="charge_gst"
                                                                checked={formValue?.charge_gst === 1}
                                                                onChange={(e) => setFormValue((s) => ({ ...s, charge_gst: 1, gst_percentage: {}, receiving_state: {} }))}
                                                            />
                                                            <label htmlFor="forward_charge_mechanism" className="form-check-label"> Reverse charge mechanism (RCM) <span className='_btmSmall_txt'>GST will be paid & Manage by Party </span></label>

                                                            {formValue?.charge_gst === 1 && <div className='pr_procssBx_grid singleDiv mt-3'>
                                                                <div className='singleDiv'>
                                                                    <CustomSelect
                                                                        // options={masterData?.gst_percentage_list?.map((el) => {
                                                                        //     return {
                                                                        //         label: el?.name,
                                                                        //         value: el?.id,
                                                                        //     }
                                                                        // })}
                                                                        options={[{ label: '5 %', value: 5 }]} // {[{ label: '12 %', value: 12 }]}
                                                                        name="gst_percentage"
                                                                        label="GST %"
                                                                        placeholder="GST %"
                                                                        value={formValue?.gst_percentage?.value ? formValue?.gst_percentage : {}}
                                                                        error={formError["gst_percentage.label"]}
                                                                        onSelect={(data) => onhandleSelect(data, 'gst_percentage')}
                                                                    />
                                                                </div>

                                                                {/* <div className='halfDiv'>
                                                                    <CustomSelect
                                                                        options={masterData?.tds_section_list?.map((el) => {
                                                                            return {
                                                                                label: el?.name,
                                                                                value: el?.id,
                                                                            }
                                                                        })}
                                                                        name="tds"
                                                                        label="TDS % 1/2"
                                                                        placeholder="TDS % 1/2"
                                                                        value={formValue?.tds?.value ? formValue?.tds : {}}
                                                                        error={formError["tds.label"]}
                                                                        onSelect={(data) => onhandleSelect(data, 'tds')}
                                                                    />
                                                                </div> */}

                                                            </div>}
                                                        </div>

                                                        <div className="_dualCheckr_bx" >
                                                            <input
                                                                className="form-check-input"
                                                                id="reverse_charge_mechanism"
                                                                type="radio"
                                                                name="charge_gst"
                                                                checked={formValue?.charge_gst === 2}
                                                                onChange={(e) => setFormValue((s) => ({ ...s, charge_gst: 2, gst_percentage: {}, receiving_state: {} }))}
                                                            />
                                                            <label htmlFor="reverse_charge_mechanism" className="form-check-label"> Forward charge mechanism (FCM) <span className='_btmSmall_txt'>GST will be paid & Manage by Own</span></label>

                                                            {formValue?.charge_gst === 2 && <div className='pr_procssBx_grid singleDiv mt-3'>
                                                                <div className='singleDiv'>
                                                                    <CustomSelect
                                                                        // options={masterData?.gst_percentage_list?.map((el) => {
                                                                        //     return {
                                                                        //         label: el?.name,
                                                                        //         value: el?.id,
                                                                        //     }
                                                                        // })}
                                                                        options={[{ label: '18 %', value: 18 }]}
                                                                        name="gst_percentage"
                                                                        label="GST % "
                                                                        placeholder="GST % "
                                                                        value={formValue?.gst_percentage?.value ? formValue?.gst_percentage : {}}
                                                                        error={formError["gst_percentage.label"]}
                                                                        onSelect={(data) => onhandleSelect(data, 'gst_percentage')}
                                                                    />
                                                                </div>

                                                                {/* <div className='halfDiv'>
                                                                    <CustomSelect
                                                                        options={masterData?.tds_section_list?.map((el) => {
                                                                            return {
                                                                                label: el?.name,
                                                                                value: el?.id,
                                                                            }
                                                                        })}
                                                                        name="tds"
                                                                        label="TDS % 1/2"
                                                                        placeholder="TDS % 1/2"
                                                                        value={formValue?.tds?.value ? formValue?.tds : {}}
                                                                        error={formError["tds.label"]}
                                                                        onSelect={(data) => onhandleSelect(data, 'tds')}
                                                                    />
                                                                </div> */}

                                                                <div className='singleDiv'>
                                                                    <CustomSelect
                                                                        options={states?.length > 0 ? states?.map((el) => {
                                                                            return {
                                                                                ...el,
                                                                                label: el?.name,
                                                                                value: el?.name,
                                                                            }
                                                                        }) : []}
                                                                        name="receiving_state"
                                                                        isDropdownTop={true}
                                                                        label="Select Receiving State *"
                                                                        placeholder="Select Receiving State *"
                                                                        value={formValue?.receiving_state?.value ? formValue?.receiving_state : {}}
                                                                        error={formError["receiving_state.label"]}
                                                                        onSelect={(data) => onhandleSelect(data, 'receiving_state')}
                                                                    />
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className='_billRaiseFooter'>
                    <div className='prevDiscard_bx'>
                        {/* <button className='_previousBtn' onClick={(e) => navigate('/invoicing')}><span>Previous</span></button> */}
                        <button className='_discardBtn' onClick={(e) => discardHandlerFunction(e)}><span>Discard</span></button>
                    </div>

                    <div>
                        <button className='_stepSuccessBtn' onClick={(e) => handleSubmit(e)}>Next : Select  LR</button>
                    </div>
                </div>
            </div >
            {leaveShowConfirm && (
                <ConfirmModalFor {...leaveModalProps}>
                    <>
                        <p className="_confirmPrx"> Do you really want leave this Page ?</p>
                    </>
                </ConfirmModalFor>
            )
            }
            <input ref={hiddenInputRef} type="hidden" />
            {
                showBackModal && (
                    <ConfirmModalFor {...backModalProps}>
                        <>
                            <p className="_confirmPrx"> Do you really want leave this Page ?</p>
                        </>
                    </ConfirmModalFor>
                )
            }

            {isOpenInvoiceSeries && <BranchSeriesInvoiceModal {...isInvoiceSeriesModalProps} />}

            {showAddNewInvoiceSeries && <AddNewSeriesInvoiceModal {...addNewSeriesInvoiceModalProps} />}

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
            >
                {showOffcanvas && (
                    <AddMasterLocationModal
                        isOpen={showOffcanvas}
                        onClose={(e) => {
                            setAddressId({ id: "", title: "location", view: false });
                            getDataConsignorDetails(formValue?.consignor_id?._id, StorageService.getCompanyId(), { stateUpdate: true, action: false });
                            setShowOffcanvas(false);
                        }}
                        detailsData={detailsData}
                        id={addressId}
                        callBackDropdownLocationUpdate={(value) => setFormValue((s) => ({ ...s, consignor_location: value }))}
                        whileEditLocationAddNewLocation={false}
                    />
                )}
            </div>
            <div className={showOffcanvas ? "offBack_drop" : ""}></div>
        </>
    )
}

export default BillRaise